export default __webpack_public_path__ + "static/media/icon5.c8d47a62.svg";